import { Inject, Injectable } from '@angular/core';

import { L10nBase } from '@skylab-shared/core';

import { L10n } from '@skylab-angular-shared/core';
import { ServiceGridColumn } from '@skylab-angular-shared/ui';
import { ChosenColumn } from '../printing-pattern-dialog.component';

export type PrintingPatternDialogGridColumnIdentitiy = 'move' | 'delete' | 'width' | 'name' | 'order';
export type PrintingPatternDialogGridCustomTemplates = 'gridMoveRowCell' | 'printingPatternGridWithCell';

@Injectable({
    providedIn: 'root'
})
export class PrintingPatternDialogGridService {

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase
    ) {}

    public getGridColumns(
        methods: {
            remove: (entity: ChosenColumn) => void
        }): ServiceGridColumn<PrintingPatternDialogGridColumnIdentitiy, unknown, ChosenColumn, unknown, PrintingPatternDialogGridCustomTemplates>[] {
        return [
            {
                header: this.l10n._T('scenes.configuration.shared.printing-pattern.dialog.grid.columns.lp.title'),
                cell: entity => `${entity.order}`,
                width: '50px',
                minWidth: '50px',
                styleClass: 'column--align-center',
                identityName: 'order',
                columnDef: 'order',
                isMovable: false,
                isResizable: false,
            },
            {
                header: this.l10n._T('scenes.configuration.shared.printing-pattern.dialog.grid.columns.name.title'),
                cell: entity => entity.name,
                fillingColumn: true,
                minWidth: '180px',
                identityName: 'name',
                columnDef: 'name',
                isMovable: false,
                isResizable: false,
            },
            {
                header: this.l10n._T('scenes.configuration.shared.printing-pattern.dialog.grid.columns.width.title'),
                styleClass: 'column--align-right',
                width: '130px',
                columnDef: 'width',
                minWidth: '130px',
                identityName: 'width',
                isMovable: false,
                isResizable: false,
                template: 'printingPatternGridWithCell'
            },
            {
                identityName: 'move',
                columnDef: 'move',
                template: 'gridMoveRowCell',
                isMovable: false,
                styleClass: ['cell--sticky', 'cell--no-space'],
                isResizable: false,
            },
            {
                identityName: 'delete',
                template: 'buttonTemplate',
                columnDef: 'Delete',
                icon: 'remove',
                action: (_, entity) => methods.remove(entity),
                cellTooltip: () => this.l10n._T('scenes.configuration.shared.printing-pattern.dialog.grid.buttons.delete'),
                styleClass: ['cell--button', 'cell--no-space'],
                isMovable: false,
                isResizable: false,
            }
        ];
    }
}
